import { on } from "@ngrx/store";
import { ApplicationStore } from "../../../application.state";
import { CreditChecksActions } from "./credit-checks.actions";

// **************************************************************************
// CREDIT CHECKS REDUCER
// Prepared for future list functionality
// **************************************************************************

const load = on(CreditChecksActions.load, (state: ApplicationStore) => ({
    ...state,
    data: {
        ...state.data,
        creditCheck: {
            ...state.data.creditCheck,
            creditChecksLoading: true,
        },
    },
}));

const loadSuccess = on(CreditChecksActions.loadSuccess, (state: ApplicationStore, { items }) => ({
    ...state,
    data: {
        ...state.data,
        creditCheck: {
            ...state.data.creditCheck,
            creditChecks: items,
            creditChecksLoading: false,
        },
    },
}));

const loadFailure = on(CreditChecksActions.loadFailure, (state: ApplicationStore, { error }) => ({
    ...state,
    data: {
        ...state.data,
        error,
        creditCheck: {
            ...state.data.creditCheck,
            creditChecksLoading: false,
        },
    },
}));

export const creditChecksReducer = [load, loadSuccess, loadFailure];
